<template>
  <RevCard class="flex-1 p-24">
    <WithSkeletonLoader :is-loading="status === 'pending'">
      <EmptyBlockContent
        v-if="hasNotFillTheForm"
        @add="openAddContactFormModal"
      />
      <HasContactDetailBlockContent
        v-if="hasContactDetails"
        :contact-details="data?.contactDetails!"
        @edit="openAddContactFormModal"
      />
      <WaivedBlockContent v-if="hasWaived" @edit="openAddContactFormModal" />
    </WithSkeletonLoader>
  </RevCard>

  <AddContactFormModal />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { sellerProfileAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { RevCard } from '@ds/components/Card'
import { openModal } from '@ds/components/ModalBase'

import WithSkeletonLoader from '~/scopes/profile/pages/components/WithSkeletonLoader/WithSkeletonLoader.vue'

import { FORM_MODAL_NAME } from './components/AddContactFormModal/AddContactFormModal.constants'
import AddContactFormModal from './components/AddContactFormModal/AddContactFormModal.vue'
import EmptyBlockContent from './components/EmptyBlockContent/EmptyBlockContent.vue'
import HasContactDetailBlockContent from './components/HasContactDetailBlockContent/HasContactDetailBlockContent.vue'
import WaivedBlockContent from './components/WaivedBlockContent/WaivedBlockContent.vue'

const { data, status } = await useHttpFetch(
  sellerProfileAPI.getDsaContactDetails,
)

const hasNotFillTheForm = computed(
  () => !data.value?.sellerId && !data.value?.contactDetails,
)
const hasWaived = computed(
  () => data.value?.sellerId && !data.value?.contactDetails,
)
const hasContactDetails = computed(
  () => data.value?.sellerId && data.value?.contactDetails,
)

function openAddContactFormModal() {
  openModal(FORM_MODAL_NAME)
}
</script>
